var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{staticClass:"label text-center"},[_vm._v("\n    "+_vm._s(_vm.label)+"\n  ")]),_c('div',{staticClass:"dots-wrapper"},[_c('div',{staticClass:"dot active",class:{ completed: _vm.step === 2 }}),_c('div',{staticClass:"dot last-dot",class:{ active: _vm.step === 2 }})])])
}
var staticRenderFns = []

export { render, staticRenderFns }